import type {HousekeepingPreparation, HousekeepingRoomStatus} from "../../pages/housekeeping/types/housekeeping";

/**
 * Les préparations du jour d'une chambre — règles partagées entre le web et « Mes chambres »
 * au mobile. Module feuille : seuls des `import type` (effacés au build), pour que le mobile
 * puisse l'atteindre sans franchir la frontière du socle. Le web le ré-exporte depuis
 * `pages/housekeeping/helpers/preparations.ts`.
 */

export function pendingPreparations(room: Pick<HousekeepingRoomStatus, 'preparations'>): HousekeepingPreparation[] {
    return (room.preparations ?? []).filter(p => p.status !== 'completed');
}

/** Refus serveur de fin de ménage : une préparation du jour reste à faire. */
export function isPendingPreparationsError(error: unknown): boolean {
    const data = (error as {response?: {data?: {code?: string}}} | null)?.response?.data;
    return data?.code === 'pending_preparations';
}

/** Préparations restantes par chambre (badge cadeau du tableau). */
export function preparationCountsByRoom(rooms: HousekeepingRoomStatus[]): Record<number, number> {
    const counts: Record<number, number> = {};
    for (const room of rooms) {
        const n = pendingPreparations(room).length;
        if (n > 0) counts[room.service_id] = n;
    }
    return counts;
}
